import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';
export const getQrCodeCustomerSingleOrder = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qrcode',
    headers: getHeaders(),
  });
};

export const getQrCodeByItem = (id, storeId, orderId, orderItemId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qrcode-by-item/' + orderItemId ,
    headers: getHeaders(),
  });
};
